// src/store/Campuses/campusesActions.js
import * as actionTypes from "../ActionTypes";

// 🔹 Save Campus
export const saveCampusRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CAMPUS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCampusSuccess = (data) => ({
  type: actionTypes.SAVE_CAMPUS_SUCCESS,
  payload: data,
});

export const saveCampusFailure = (error) => ({
  type: actionTypes.SAVE_CAMPUS_FAILURE,
  payload: error,
});
export const deleteCampusRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.DELETE_CAMPUS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const deleteCampusSuccess = (data) => ({
  type: actionTypes.DELETE_CAMPUS_SUCCESS,
  payload: data,
});

export const deleteCampusFailure = (error) => ({
  type: actionTypes.DELETE_CAMPUS_FAILURE,
  payload: error,
});
export const updateCampusRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CAMPUS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});
export const updateCampusSuccess = (data) => ({
  type: actionTypes.UPDATE_CAMPUS_SUCCESS,
  payload: data,
});
export const updateCampusFailure = (error) => ({
  type: actionTypes.UPDATE_CAMPUS_FAILURE,
  payload: error,
});
// 🔹 Save Campus Gallery
export const saveCampusGalleryRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_CAMPUS_GALLERY_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveCampusGallerySuccess = (data) => ({
  type: actionTypes.SAVE_CAMPUS_GALLERY_SUCCESS,
  payload: data,
});

export const saveCampusGalleryFailure = (error) => ({
  type: actionTypes.SAVE_CAMPUS_GALLERY_FAILURE,
  payload: error,
});
// 🔹 Update Campus Gallery
export const updateCampusGalleryRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_CAMPUS_GALLERY_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateCampusGallerySuccess = (data) => ({
  type: actionTypes.UPDATE_CAMPUS_GALLERY_SUCCESS,
  payload: data,
});

export const updateCampusGalleryFailure = (error) => ({
  type: actionTypes.UPDATE_CAMPUS_GALLERY_FAILURE,
  payload: error,
});

// 🔹 Delete Campus Gallery
export const deleteCampusGalleryRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.DELETE_CAMPUS_GALLERY_REQUEST,
  payload: { apiPayloadRequest },
  callback, // ✅ keep callback outside payload (important)
});


export const deleteCampusGallerySuccess = (data) => ({
  type: actionTypes.DELETE_CAMPUS_GALLERY_SUCCESS,
  payload: data,
});

export const deleteCampusGalleryFailure = (error) => ({
  type: actionTypes.DELETE_CAMPUS_GALLERY_FAILURE,
  payload: error,
});
